/**
 * Coach avatar — a small circle with "GI" inside, ringed in Spark-blue.
 * Used beside each Coach message and as the header glyph.
 */

import { cn } from '@/utils/cn';

export function Avatar({ size = 'sm', className }: { size?: 'sm' | 'md'; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-spark-soft font-mono font-semibold text-spark ring-2 ring-spark/40',
        size === 'sm' ? 'h-7 w-7 text-[10px]' : 'h-10 w-10 text-sm',
        className,
      )}
    >
      GI
    </span>
  );
}
